import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import PointUnits from './PointUnits';

const QaDashboard = ({ scrollTop }) => {
  const location = useLocation();
  return (
    <div className="row grid-container-lg qa-dash">
      <PointUnits scrollTop={scrollTop} location={location} />
    </div>
  );
};

QaDashboard.propTypes = {
  scrollTop: PropTypes.func.isRequired,
};

export default QaDashboard;
